/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GMN } from "./GMN";
import { GMNFromJSON, GMNFromJSONTyped, GMNToJSON, GMNToJSONTyped } from "./GMN";

/**
 *
 * @export
 * @interface ApiGmnGmnsList200Response
 */
export interface ApiGmnGmnsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGmnGmnsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGmnGmnsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmnGmnsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GMN>}
   * @memberof ApiGmnGmnsList200Response
   */
  results: Array<GMN>;
}

/**
 * Check if a given object implements the ApiGmnGmnsList200Response interface.
 */
export function instanceOfApiGmnGmnsList200Response(
  value: object
): value is ApiGmnGmnsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGmnGmnsList200ResponseFromJSON(json: any): ApiGmnGmnsList200Response {
  return ApiGmnGmnsList200ResponseFromJSONTyped(json, false);
}

export function ApiGmnGmnsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmnGmnsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GMNFromJSON),
  };
}

export function ApiGmnGmnsList200ResponseToJSON(json: any): ApiGmnGmnsList200Response {
  return ApiGmnGmnsList200ResponseToJSONTyped(json, false);
}

export function ApiGmnGmnsList200ResponseToJSONTyped(
  value?: ApiGmnGmnsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GMNToJSON),
  };
}
